import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/images/Arrow_right.png'
import _imports_1 from '@/assets/images/Duplizieren.png'
import _imports_2 from '@/assets/images/Trash.png'


const _hoisted_1 = { class: "overflow-x-auto shadow mt-4 mb-[3%]" }
const _hoisted_2 = { class: "w-full border-[1px] text-left lg:text-xl" }
const _hoisted_3 = { class: "text-white" }
const _hoisted_4 = { class: "border-b-[1px] border-black bg-[#545656] py-2" }
const _hoisted_5 = {
  key: 0,
  class: "w-[10%] font-medium p-3 text-center",
  id: "header_Bearbeiten"
}
const _hoisted_6 = {
  key: 1,
  id: "header_Duplizieren",
  class: "w-[10%] font-medium p-3 text-center"
}
const _hoisted_7 = {
  key: 2,
  id: "header_Löschen",
  class: "w-[10%] font-medium p-3 text-center"
}
const _hoisted_8 = { id: "contacts_body" }
const _hoisted_9 = {
  class: "w-[8%] font-medium p-3",
  id: "body_ID"
}
const _hoisted_10 = {
  class: "w-[30%] font-medium p-3",
  id: "body_Organisation"
}
const _hoisted_11 = {
  class: "w-[16%] font-medium p-3",
  id: "body_Name"
}
const _hoisted_12 = {
  class: "w-[16%] font-medium p-3",
  id: "body_Vorname"
}
const _hoisted_13 = {
  key: 0,
  class: "w-[10%] font-medium p-3",
  id: "body_Bearbeiten"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "w-[10%] font-medium p-3",
  id: "body_Duplizieren"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 2,
  class: "w-[10%] font-medium p-3",
  id: "body_Löschen"
}
const _hoisted_18 = ["onClick"]

import { Contact } from '@/model/types'
    import useContactStore from '@/utils/useContactStore'
    import { computed } from 'vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ContactsTable',
  props: {
    deleteMethod: { type: Function },
    contacts: {},
    selectMethod: { type: Function },
    duplicateMethod: { type: Function },
    load: { type: Function },
    contactsCount: {}
  },
  setup(__props: any) {

    const { contactsLinks } = useContactStore()
    console.log(contactsLinks.value)

    const hasUpdateContactLink = computed(() =>
        contactsLinks.value.some((link) => link.rel === 'contact/update')
    )
    const hasCreateContactLink = computed(() =>
        contactsLinks.value.some((link) => link.rel === 'contact/create')
    )
    const hasDeleteContactLink = computed(() =>
        contactsLinks.value.some((link) => link.rel === 'contact/delete')
    )

    const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", _hoisted_3, [
        _createElementVNode("tr", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("th", {
            class: "w-[8%] font-medium p-3",
            id: "header_ID"
          }, "ID", -1)),
          _cache[1] || (_cache[1] = _createElementVNode("th", {
            class: "w-[30%] font-medium p-3",
            id: "header_Organisation"
          }, "Organisation", -1)),
          _cache[2] || (_cache[2] = _createElementVNode("th", {
            class: "w-[16%] font-medium p-3",
            id: "header_Name"
          }, "Name", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("th", {
            class: "w-[16%] font-medium p-3",
            id: "header_Vorname"
          }, "Vorname", -1)),
          (hasUpdateContactLink.value || __props.selectMethod)
            ? (_openBlock(), _createElementBlock("th", _hoisted_5, " Bearbeiten "))
            : _createCommentVNode("", true),
          (hasCreateContactLink.value)
            ? (_openBlock(), _createElementBlock("th", _hoisted_6, " Duplizieren "))
            : _createCommentVNode("", true),
          (hasDeleteContactLink.value)
            ? (_openBlock(), _createElementBlock("th", _hoisted_7, " Löschen "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("tbody", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.contacts?.slice(0, __props.contactsCount), (contact) => {
          return (_openBlock(), _createElementBlock("tr", {
            class: "border-b-2",
            key: String(contact.contactId),
            "data-cy": "contact-row"
          }, [
            _createElementVNode("td", _hoisted_9, _toDisplayString(contact.contactId), 1),
            _createElementVNode("td", _hoisted_10, _toDisplayString(contact.organisation?.name), 1),
            _createElementVNode("td", _hoisted_11, _toDisplayString(contact.person?.familyName), 1),
            _createElementVNode("td", _hoisted_12, _toDisplayString(contact.person?.firstName), 1),
            (hasUpdateContactLink.value || __props.selectMethod)
              ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (props.selectMethod?.(contact)),
                    class: "w-full",
                    "data-cy": "update_button"
                  }, [...(_cache[4] || (_cache[4] = [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: "Open",
                      class: "lg:w-[35px] w-[20px] mx-auto"
                    }, null, -1)
                  ]))], 8, _hoisted_14)
                ]))
              : _createCommentVNode("", true),
            (hasCreateContactLink.value)
              ? (_openBlock(), _createElementBlock("td", _hoisted_15, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (props.duplicateMethod?.(contact)),
                    class: "w-full",
                    "data-cy": "duplicate_button"
                  }, [...(_cache[5] || (_cache[5] = [
                    _createElementVNode("img", {
                      src: _imports_1,
                      alt: "Open",
                      class: "lg:w-[35px] w-[20px] mx-auto"
                    }, null, -1)
                  ]))], 8, _hoisted_16)
                ]))
              : _createCommentVNode("", true),
            (hasDeleteContactLink.value)
              ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (props.deleteMethod?.(contact.contactId ?? 0)),
                    class: "w-full",
                    "data-cy": "delete_button"
                  }, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("img", {
                      src: _imports_2,
                      alt: "Del",
                      class: "lg:w-[35px] w-[20px] mx-auto"
                    }, null, -1)
                  ]))], 8, _hoisted_18)
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})